const state = {
    //與權限搭配
    sideBar: {
        home: {
            code: "home",
            name: "總覽",
            focus: false,
            children: [
                {
                    code: "homeforging3",
                    name: "鍛造三部",
                    focus: false,
                    disabled: false,
                    children: []
                },
            ]
        },
        elecboard: {
            code: "elecboard",
            name: "即時看板",
            focus: false,
            children: [
                {
                    code: "forging3",
                    name: "鍛造三部",
                    focus: false,
                    disabled: false,
                    children: [
                        {
                            code: "preheating",
                            name: "保溫爐",
                            focus: false,
                            disabled: false,
                            children: []
                        },
                        {
                            code: "heating",
                            name: "加熱爐",
                            focus: false,
                            disabled: false,
                            children: []
                        },
                        {
                            code: "forging",
                            name: "鍛造/熱切機",
                            focus: false,
                            disabled: false,
                            children: []
                        },
                        {
                            code: "annealing",
                            name: "退火爐",
                            focus: false,
                            disabled: false,
                            children: []
                        },
                    ]
                },
            ]
        },
        activation: {
            code: "activation",
            name: "稼動率",
            focus: false,
            children: []
        },
        operatelog: {
            code: "operatelog",
            name: "運轉日誌",
            focus: false,
            children: []
        },
        workorderhistory: {
            code: "workorderhistory",
            name: "工單履歷",
            focus: false,
            children: []
        },
        deviceManagement: {
            code: "deviceManagement",
            name: "設備管理",
            focus: false,
            children: [
                {
                    code: "maintenance",
                    name: "週期性保養",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "deviceSearch",
                    name: "設備資料查詢",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "troubleshooting",
                    name: "故障報修",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "maintenanceHistory",
                    name: "維修履歷",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "spareManagement",
                    name: "備品管理",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "deviceCompany",
                    name: "設備商資訊",
                    focus: false,
                    disabled: false,
                    children: []
                },
            ]
        },
    },
    sideBarSelect: null,
    other: {
        home: {
            site: {
                "homeall": { name: "全場域" },
                "homeforging3": { name: "鍛造三部" },
                "homeforging3": { name: "鍛造三部" },
            }
        },
        elecboard: {
            site: {
                "elecboardofco1": {
                    name: "岡山廠",
                    oper: {
                        "elecboardofco1head": {
                            name: "打頭",
                            device: ["B10", "B12", "B46", "B47", "B48", "B50", "B51", "B52", "B14", "B16", "B44", "B49", "B65", "B66"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco1thread": {
                            name: "輾牙",
                            device: ["T14", "T17", "T18", "T23", "T51", "T53", "T54", "T64", "T65", "T68", "T69", "T70", "T71", "T108", "T109"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco1heat": {
                            name: "熱處理",
                            device: ["A", "B", "C", "D", "E"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        }
                    }
                },
                "elecboardofco2": {
                    name: "梓官廠",
                    oper: {
                        "elecboardofco2head": {
                            name: "打頭",
                            device: ["F12", "F31", "F32", "F43", "F44", "F45", "F46", "F47", "F48", "F49", "F50", "B01", "B02", "B05", "B06", "B07", "B15", "B17", "B18", "B19", "B20", "B21", "B32", "B33", "B34", "B35", "B36", "B37", "B38", "B39", "B53", "B54", "B55", "B56", "B57", "B58", "B59", "B60", "F03", "F04", "F05", "F06", "F07", "F08", "F09", "F10", "F11", "F13", "F14", "F15", "F16", "F17", "F33", "F34", "F35", "F36", "F37", "F38", "F39", "F40", "F41", "F42", "F51", "F52", "F53", "F54", "F55", "F56", "B29", "B30", "B45"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco2thread": {
                            name: "輾牙",
                            device: ["R01", "R02", "R03", "R04", "R05", "R06", "R08", "R09", "R10", "R11", "R16", "R17", "R18", "R19", "R20", "R21", "R22", "R23", "R24", "R25", "R26", "R27", "R28", "R29", "R30", "R31", "R32", "R33", "R34", "R35", "R36", "R37", "R38", "R39", "R40", "R41", "R42", "S04", "S05", "S06", "S43", "S49", "T01", "T09", "T11", "T13", "T22", "T24", "T28", "T43", "T47", "T61", "T98", "T99", "T100", "T101", "T102", "T103", "T104", "T106"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco2heat": {
                            name: "熱處理",
                            device: ["A2", "B2", "C2", "D2"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco2pk": {
                            name: "包裝",
                            device: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "elecboardofco2cn": {
                            name: "裝櫃",
                            device: ["A1", "A2", "A3"],
                            user: [{ name: 'USER', position: '課長', image: 'user.png' }, { name: 'USER', position: '組員', image: 'user.png' }]
                        }
                    }
                },
                "elecboardforging3": {
                    name: "鍛造三部",
                    oper: {
                        "preheating": {
                            name: "保溫爐",
                            device: ["PH01", "PH02", "PH03", "PH04"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "heating": {
                            name: "加熱爐",
                            device: ["B01", "B02", "B04", "B05"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "forging": {
                            name: "鍛造/熱切機",
                            device: ["F01", "C01"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "annealing": {
                            name: "退火爐",
                            device: ["A01", "A02", "A03", "A04", "A05", "A06", "A07", "A08", "A09", "A10", "A11", "A12"],
                            user: [{ name: 'USER', position: '課長', image: 'user.png' }, { name: 'USER', position: '組員', image: 'user.png' }]
                        }
                    }
                },
                "heading": {
                    name: "打頭",
                    oper: {
                        "headinggroup1": {
                            name: "成一組",
                            device: ["B06", "B07", "B10", "B12", "B46", "B47", "B48", "B50", "B51", "B52"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "headinggroup2": {
                            name: "成二組",
                            device: ["B14", "B16", "B32", "B33", "B34", "B35", "B36", "B37", "B38", "B39", "B44", "B49", "B53", "B54", "B55", "B56", "B57", "B58", "B59", "B60"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "headinggroup4": {
                            name: "成四組",
                            device: ["F12", "F31", "F32", "F43", "F44", "F45", "F46", "F47", "F48", "F49", "F50", "B01", "B02", "B05", "B15", "B17", "B18", "B19", "B20", "B21"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "headinggroup5": {
                            name: "成五組",
                            device: ["F03", "F04", "F05", "F06", "F07", "F08", "F09", "F10", "F11", "F13", "F14", "F15", "F16", "F17", "F33", "F34", "F35", "F36", "F37", "F38", "F39", "F40", "F41", "F42", "F51", "F52", "F53", "F54", "F55", "F56", "B29", "B30", "B45"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        }
                    }
                },
                "thread": {
                    name: "輾牙",
                    oper: {
                        "threadgroup1": {
                            name: "輾一組",
                            device: ["R09", "T13", "T14", "T17", "T18", "T22", "T23", "T24", "T28", "T43", "T47", "T51", "T53", "T54", "T61", "T64", "T65", "T68", "T69", "T70", "T71", "T98", "T100", "T101", "T102", "T103"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "threadgroup2": {
                            name: "輾二組",
                            device: ["R01", "R02", "R03", "R04", "R05", "R06", "R08", "R10", "R11", "R16", "R17", "R18", "R19", "R20", "R21", "R22", "R23", "R24", "R25", "R26", "R27", "R28", "R29", "R30", "R31", "R32", "R33", "R34", "R35", "R36", "R37", "R38", "R39", "R40", "R41", "R42", "S04", "S05", "S06", "S43", "S49", "T01", "T09", "T11", "T99"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        }
                    }
                },
                "heat": {
                    name: "熱處理",
                    oper: {
                        "heatgroup1": {
                            name: "熱一組",
                            device: ["A", "B", "C", "D", "E"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        },
                        "heatgroup2": {
                            name: "熱二組",
                            device: ["A2", "B2", "C2", "D2"],
                            user: [{ name: 'USER', position: '組長', image: 'user.png' }]
                        }
                    }
                },
                "package": {
                    name: "包裝",
                    device: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                    user: []
                },
                "container": {
                    name: "裝櫃",
                    device: ["A1", "A2", "A3"],
                    user: [{ name: 'USER', position: '課長', image: 'user.png' }, { name: 'USER', position: '組員', image: 'user.png' }]
                },
            }
        },
    },
    sideNavPath:[]
};
const getters = {
    get_sideBar: state => {
        return state.sideBar;
    },
    get_sideBarSelect: state => {
        return state.sideBarSelect;
    },
    get_sideBarNote: state => {
        return state.other;
    },
    get_sideNavPath: state => {
        return state.sideNavPath;
    },
};
const actions = {
    set_sideBar(context, object) {
        context.commit("SET_SIDEBAR", object);
    },
    set_sideBarSelect(context, array) {
        context.commit("SET_SIDEBARSELECT", array);
    },
};
const mutations = {
    SET_SIDEBAR(state, object) {
        state.sideBar = object;console.log(object)
    },
    SET_SIDEBARSELECT(state, array) {
        console.log(state.sideBar);
        state.sideNavPath = array;
        console.log(array);
        let page = array[0];
        if (page == 'elecboard') {
            let site = array[1];
            let oper = array[2];
            let data = state.other.elecboard.site;
            if (site == 'package' || site == 'container') {
                state.sideBarSelect = {
                    page: page,
                    site: {
                        id: site,
                        name: data[site].name
                    },
                    oper: {
                        id: site,
                        name: data[site].name,
                        device: data[site].device,
                        user: data[site].user
                    },
                    change: Math.random()
                };
            } else {
                state.sideBarSelect = {
                    page: page,
                    site: {
                        id: site,
                        name: data[site].name
                    },
                    oper: {
                        id: oper,
                        name: data[site].oper[oper].name,
                        device: data[site].oper[oper].device,
                        user: data[site].oper[oper].user
                    },
                    change: Math.random()
                };
            }
        } else if (page == 'home') {
            const children = state.sideBar.home.children;
            // 檢查是否存在 homeall
            if (!children.hasOwnProperty(array[1])) {
                const keys = Object.keys(children);
                if (keys.length > 0) {
                    array[1] = keys[0];
                }
            }
            let site = array[1];
            let data = state.sideBar.home.children;
            state.sideBarSelect = {
                page: page,
                site: site,
                siteName: data[site].name,
                change: Math.random()
            }
        } else if (page == 'permissionmanagement') {
            let pageList = array[1];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                change: Math.random()
            }
        } else if (page == 'activation') {
            let pageList = array[1];
            let pageListChild = array[2];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                pageListChild: pageListChild,
                change: Math.random()
            }
        } else if (page == 'errorhistory') {
            let pageList = array[1];
            let pageListChild = array[2];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                pageListChild: pageListChild,
                change: Math.random()
            }
        } else if (page == 'ordermanagement') {
            let pageList = array[1];
            let pageListChild = array[2];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                pageListChild: pageListChild,
                change: Math.random()
            }
        } else if (page == 'devicemanagement') {
            let pageList = array[1];
            let pageListChild = array[2];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                pageListChild: pageListChild,
                change: Math.random()
            }
        } else if (page == 'statisticalreports') {
            let pageList = array[1];
            let pageListChild = array[2];
            state.sideBarSelect = {
                page: page,
                pageList: pageList,
                pageListChild: pageListChild,
                change: Math.random()
            }
        } else {
            state.sideBarSelect = {
                page: page,
                change: Math.random()
            }
        }
        console.log(state.sideBarSelect);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
